import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)
import Bmxx from '@/views/bmgl/bmxx.vue'
import Home from '@/views/Home'
import ShopHome from '@/views/ShopHome'
import LoginRes from "../views/LoginRes";

export default new Router({
  routes: [
    {
      path: '/',
      name: 'ShopHome',
      component: ShopHome
    },
    {
      path: '/LoginRes',
      name: 'LoginRes',
      component: LoginRes
    },
    {
      path: '/ShopDetail',
      name: 'ShopDetail',
      component: () => import('@/views/ShopDetail.vue'),  // 显式动态导入
    },
    {
      path: '/CompanyIntro',
      name: 'CompanyIntro',
      component: () => import('@/views/CompanyIntro.vue'),  // 显式动态导入
    },
    {
      path: '/Download',
      name: 'Download',
      component: () => import('@/views/Download.vue'),  // 显式动态导入
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js